import * as React from 'react';

var _path, _g;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgUsdc = function SvgUsdc(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 120 120"
    }, props), /*#__PURE__*/ React.createElement("mask", {
        id: "mask0_839_4971",
        width: 120,
        height: 120,
        x: 0,
        y: 0,
        maskUnits: "userSpaceOnUse",
        style: {
            maskType: "luminance"
        }
    }, _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M120 0H0v120h120z"
    }))), _g || (_g = /*#__PURE__*/ React.createElement("g", {
        mask: "url(#mask0_839_4971)"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#0B53BF",
        d: "M60 120c33.137 0 60-26.863 60-60S93.137 0 60 0 0 26.863 0 60s26.863 60 60 60"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M70.8 16.313v7.725C86.211 28.688 97.498 43.013 97.498 60s-11.287 31.313-26.7 35.963v7.725C90.45 98.888 105 81.15 105 60s-14.55-38.887-34.2-43.687M22.499 60c0-16.987 11.287-31.312 26.7-35.962v-7.725c-19.65 4.8-34.2 22.537-34.2 43.687s14.55 38.888 34.2 43.688v-7.725C33.786 91.35 22.499 76.988 22.499 60"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M76.124 68.363c0-15.338-24.037-9.038-24.037-17.513 0-3.037 2.437-4.987 7.087-4.987 5.55 0 7.463 2.7 8.063 6.337h7.65c-.683-6.826-4.6-11.137-11.138-12.42v-6.03h-7.5v5.814c-7.161.912-11.662 5.083-11.662 11.286 0 15.413 24.075 9.638 24.075 17.963 0 3.15-3.038 5.25-8.176 5.25-6.712 0-8.924-2.963-9.75-7.05h-7.462c.483 7.477 5.094 12.157 12.975 13.324v5.913h7.5v-5.834c7.692-.994 12.375-5.468 12.375-12.053"
    }))));
};

export { SvgUsdc as ReactComponent };
//# sourceMappingURL=USDC.svg.es.js.map
